"use client";

import { useRouter } from "next/navigation";
import { useEffect } from "react";
import { useShellProfileData } from "@/hooks/use-shell-profile-data";

/**
 * Non-blocking onboarding gate for the authenticated shell. Replaces the old
 * server-side `redirect()` in the layout, which forced every with-navbar page
 * to await session + profile-completion before any child could paint.
 *
 * The completion signal now rides on the lightweight shell-profile fetch used
 * by the navbar and location provider, avoiding a duplicate session/profile
 * request. Guests never start that fetch and are never bounced. Renders
 * nothing.
 */
export function OnboardingGate() {
  const router = useRouter();
  const { data: shellProfile } = useShellProfileData();
  const needsOnboarding = shellProfile?.needsOnboarding ?? false;

  useEffect(() => {
    if (needsOnboarding) {
      router.replace("/onboarding");
    }
  }, [needsOnboarding, router]);

  return null;
}
